import FormSelect from '@/components/ui-components/form-select/FormSelect'
import FormSelectOption from '@/components/ui-components/form-select/FormSelectOption'

export { FormSelect as XFormSelect }
export { FormSelectOption as XFormSelectOption }
